import { useI18n, useNotification } from "#imports"
import { useOFetchCustom } from "./useOFetchCustom"
import type { User } from "~/models/User"

export const useToggleFavoriteProducts = () => {
    
    const { post: toggleFavoriteProductMutation, setUrl: setToggleFavoriteProductUrl } = useOFetchCustom("favorites")
    const { destroy: removeFavoriteProductMutation, setUrl: setRemoveFavoriteProductUrl } = useOFetchCustom("favorites")
    const notification = useNotification()
    const i18n = useI18n()
    
    const options = {
        onSuccess: () => {
            notification("positive", i18n.t("messages.product_added_to_favorites"))
        },
        onError: () => {
            notification("negative", i18n.t("messages.failed_to_add_product_to_favorites"))
        },
    }

    const toggleFavoriteProduct = async (productId: number, action: "add" | "remove") => {
        const user = useSanctumUser<User>()
        
        if (action === "add") {
            setToggleFavoriteProductUrl(`favorites/${productId}`)
            await toggleFavoriteProductMutation({
                product_id: productId,
                user_id: user.value?.id ?? -1,
            }, options)
        } else {
            setRemoveFavoriteProductUrl(`favorites/${productId}`)
            await removeFavoriteProductMutation({
                product_id: productId,
                user_id: user.value?.id ?? -1,
            }, {...options, onSuccess: () => {
                notification("positive", i18n.t("messages.product_removed_from_favorites"))
            }, onError: () => {
                notification("negative", i18n.t("messages.failed_to_remove_product_from_favorites"))
            }})
        }
    }

    return {
        toggleFavoriteProduct,
    }
}